<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  <app-page-hero
    eyebrow="CRM Contracts"
    title="Commercial Agreements"
    subtitle="Manage customer agreements, revisions, signed files, and delivery rate cards from the CRM commercial workspace.">
    <div actions>
      <p-button label="Add Contract" icon="fa-solid fa-plus" (click)="addContract()"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="getContractMetrics()"></app-page-metric-strip>
  <app-page-metric-strip [metrics]="getLifecycleDashboardMetrics()"></app-page-metric-strip>

  <app-page-data-panel
    title="Contract Repository"
    subtitle="Review active agreements, seller and buyer roles, revision status, and document ownership."
    [resultText]="'In total there are ' + contractsCount + ' contracts.'">
    <p-table [value]="contracts" dataKey="contractID" [resizableColumns]="true" styleClass="p-datatable-gridlines contracts-table"
             [tableStyle]="{ 'min-width': '56rem' }" [paginator]="true" [rows]="20" [first]="first"
             [showCurrentPageReport]="true" [totalRecords]="contractsCount" [lazy]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
             (onLazyLoad)="loadContracts($event)" [rowsPerPageOptions]="[20, 50, 100]">
      <ng-template pTemplate="header">
        <tr>
          <th>Contract</th>
          <th>Parties</th>
          <th>Lifecycle</th>
          <th>Dates</th>
          <th class="actions-column"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-contract>
        <tr>
          <td>
            <div class="contract-identity">
              <span class="contract-number">{{ contract.contractNumber }}</span>
              <span class="contract-id">#{{ contract.contractID }}</span>
            </div>
          </td>
          <td>
            <div class="party-stack">
              <div class="party-row">
                <div class="party-copy">
                  <span class="party-label">Seller (First Party)</span>
                  <span class="party-name">{{ contract.firstParty?.name || '-' }}</span>
                </div>
                <p-chip *ngIf="contract.firstPartyRep" [label]="contract.firstPartyRep.name">
                  <img src="{{ contract.firstPartyRep.imageUrl ?? 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'}}"
                       alt="{{ contract.firstPartyRep.name }}">
                </p-chip>
              </div>
              <div class="party-row">
                <div class="party-copy">
                  <span class="party-label">Buyer (Second Party)</span>
                  <span class="party-name">{{ contract.secondParty?.name || '-' }}</span>
                </div>
                <p-chip *ngIf="contract.secondPartyRep" [label]="contract.secondPartyRep.name">
                  <img src="{{ contract.secondPartyRep.imageUrl ?? 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'}}"
                       alt="{{ contract.secondPartyRep.name }}">
                </p-chip>
              </div>
            </div>
          </td>
          <td>
            <div class="lifecycle-cell">
              <p-tag [value]="contract.contractStatus || 'UNKNOWN'" [severity]="getContractSeverity(contract.contractStatus)"></p-tag>
              <span class="muted-text">{{ contract.revisions?.length || 0 }} revision{{ contract.revisions?.length === 1 ? '' : 's' }}</span>
            </div>
          </td>
          <td>
            <div class="date-stack">
              <span><strong>Created</strong> {{ contract.createdDate | date }}</span>
              <span><strong>Updated</strong> {{ contract.updatedDate | date }}</span>
            </div>
          </td>
          <td>
            <div class="flex align-items-center gap-2">
              <p-button icon="pi pi-eye" (click)="viewContract(contract)" severity="info"></p-button>
              <p-button icon="pi pi-pencil" (click)="editContract(contract)" severity="secondary"></p-button>
              <p-button icon="pi pi-trash" (click)="deleteContract(contract)" severity="danger"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          In total there are {{contractsCount}} contracts.
        </div>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
